<template>
  <div class="uva-container">
    <h-header />

    <!-- Services Section
    ==========================================-->
    <div id="tf-services" class="text-center">
      <div class="banner">
        <img src="/work/static/img/uva/bg-header.jpg" alt="" width="100%" class="banner-img">
      </div>
        <div class="container">
          <div class="col-md-12 col-sm-12 text-left">
            <div class="row">
              <div class="banner-h-detail">
                <!-- <div class="col-md-4 col-md-offset-1 col-sm-6 text-left">
                    <div class="section-title center">
                      <h2 v-text="title" class="line1">无人机设计</h2>
                  </div>
                </div> -->
                <div class="col-md-12 col-sm-12 text-center">
                  <div class="row">
                    <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4 col-xs-6 col-xs-offset-3 col-lg-2 col-lg-offset-5">
                      <img :src="titleImage" :alt="title" width="100%">
                    </div>
                  </div>
                  <div class="row">
                    <div class="section-title">
                      <h2 v-text="title" class="line1">无人机设计</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-detail">
                <div class="row">
                      <div class="col-md-12 col-sm-12 text-left">
                          <div v-html="htmlText" class="text-ctt">我是内容</div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
          
          <div class="left-container" :style="showLeftMenu ? 'left: 30px' : 'left:-240px'">
            <div class="u-left-menu" @click="showLeftMenufunc" v-text="!showLeftMenu ? '>>>': '<<<'"></div>
            <h3>四旋翼赛事</h3>
            <ul>
              <li><a href="/work/uva?type=XWL" :class="uvaType === 'XWL' ? 'active': ''">物流搬运赛（XWB）</a></li>
              <li><a href="/work/uva?type=XTJ" :class="uvaType === 'XTJ' ? 'active': ''">团体接力赛（XTJ）</a></li>
              <li><a href="/work/uva?type=XKG" :class="uvaType === 'XKG' ? 'active': ''">空中格斗赛（XKG）</a></li>
              <li><a href="/work/uva?type=XKZ" :class="uvaType === 'XKZ' ? 'active': ''">空中足球赛（XKZ）</a></li>
              <li><a href="/work/uva?type=XGF" :class="uvaType === 'XGF' ? 'active': ''">个人飞行赛（XGF）</a></li>
              <li><a href="/work/uva?type=XKS" :class="uvaType === 'XKS' ? 'active': ''">个人射击赛（XKS）</a></li>
            </ul>
          </div>   
        </div>
        <div class="row text-center line-box">
            <ul class="col-md-12">
              <li class="col-md-2"><a href="/work/uva?type=XWL" :class="uvaType === 'XWL' ? 'active': ''">物流搬运赛（XWB）</a></li>
              <li class="col-md-2"><a href="/work/uva?type=XTJ" :class="uvaType === 'XTJ' ? 'active': ''">团体接力赛（XTJ）</a></li>
              <li class="col-md-2"><a href="/work/uva?type=XKG" :class="uvaType === 'XKG' ? 'active': ''">空中格斗赛（XKG）</a></li>
              <li class="col-md-2"><a href="/work/uva?type=XKZ" :class="uvaType === 'XKZ' ? 'active': ''">空中足球赛（XKZ）</a></li>
              <li class="col-md-2"><a href="/work/uva?type=XGF" :class="uvaType === 'XGF' ? 'active': ''">个人飞行赛（XGF）</a></li>
              <li class="col-md-2"><a href="/work/uva?type=XKS" :class="uvaType === 'XKS' ? 'active': ''">个人射击赛（XKS）</a></li>
            </ul>
        </div>
    </div>
    <h-footer />
  </div>
</template>
<script>
import Header from '../../components/header'
import Footer from '../../components/footer'
// const UVA_design = () => import(/* webpackChunkName: 'uva-design', webpackPrefetch: true */'./detail/design')
// const UVA_verfication = () => import(/* webpackChunkName: 'uva-verfication', webpackPrefetch: true */'./detail/verification')

const detailDictionary = {
  'design': '无人机数字孪生体模型的设计',
  'verification': '无人机数字孪生飞行验证',
  'XGF': '个人飞行赛（XGF）',
  'XWL': '物流搬运赛（XWB）',
  'XKS': '个人空中射击赛（XKS）',
  'GKZ': '固定翼赛空中侦察赛竞赛规则（GKZ）',
  'XTJ': '团体接力赛（XTJ）',
  'XKZ': '空中足球赛（XKZ）',
  'XKG': '空中格斗赛（XKG）',
}

const imageDictionary = {
  'design': '/work/static/img/services/t3.jpg',
  'verification': '/work/static/img/services/t4.jpg',
  'XGF': '/work/static/img/services/xgf-icon.png',
  'XWL': '/work/static/img/services/xwl-icon.png',
  'XKS': '/work/static/img/services/xks-icon.png',
  'GKZ': '/work/static/img/services/gkz-icon.png',
  'XTJ': '/work/static/img/services/xtj-icon.jpg',
  'XKZ': '/work/static/img/services/xkz-icon.jpg',
  'XKG': '/work/static/img/services/xkg-icon.jpg',
}

export default {
  name: 'index',
  components: {
    'h-header': Header,
    'h-footer': Footer
  },
  data () {
    return {
      title: '',
      titleImage: '',
      htmlText: '',
      showLeftMenu: window.innerWidth > 1100,
      uvaType: ''
    }
  },
  created () {
    const { type } = this.$route.query
    if (type) { 
      this.uvaType = type
      this.title = detailDictionary[type]
      this.titleImage = imageDictionary[type]
      require.ensure([], function() { // 处理事件逻辑之前会先引入模块
        var htmlInfo = require(`./detail/${type}.js`)
        this.htmlText = htmlInfo.default.content
        // alert(awork.content)
    }.bind(this))
      // const htmlInfo = r => require.ensure([],() => r(require(`./detail/${this.$route.query.type}.js`)), "htmlText_ " + this.$route.query.type)
      // this.htmlText = htmlInfo.content
      // console.log(htmlInfo)
    }

  },
  mounted () {
    window.addEventListener("scroll", this.scrollToTop,true);
  },
  destroyed() {
		window.removeEventListener("scroll", this.scrollToTop,true);
	},
  methods: {
    showLeftMenufunc () {
      // 展示侧边栏
      this.showLeftMenu = !this.showLeftMenu
    },
    navigateTo (url) {
      this.$router.push(url)
    },
    // 监听回到顶部按钮距浏览器顶部的距离，滚动的距离如果大于浏览器高度时，设置 btnFlag 为true,否则就是false
		scrollToTop() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (window.innerWidth < 1100) {
        return
      }
			//为了计算距离顶部的高度，当高度大于50显示回顶部图标，小于50则隐藏
			if (scrollTop > 500) {
				this.showLeftMenu = false;
			} else {
				this.showLeftMenu = true;
			}
		},
  }
}
</script>
<style scoped lang="scss">
@import 'index';
</style>
